// Internet Explorer 11 requires polyfills and partially supported by this project.
import { createRoot } from 'react-dom/client';
import 'typeface-rubik';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import App from 'app/App';
import { initLogger } from 'utils/logger';
import * as serviceWorker from './serviceWorker';
import './index.css';

// Started before rendering so errors during rehydration,
// channel bootstrap and the first render are captured.
initLogger();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App tab="home" />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
